import React, { useContext, useMemo } from 'react'
import { _matchDisplayTypes, matchPropTypes } from '../elements/matches/MatchContent';
import { matchFilterHelpers } from '../elements/matches/MatchFilters';
import { CreatePlayoffContext } from '../create/CreatePlayoff';
import { matchDisplayTypes } from '../cnr/reducers/SportsMatchReducer';
import { _matchResultSourceTypes, useMatchResults } from './useMatchResults';

export const useMatchDisplayType = ({
  match_true,
  matchUrl,
  matchDisplayType
}) => {

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state } = createPlayoffContext ?? {};

  const _umr = useMatchResults({ match_true })
  const { results_match, hasScore, hasScores, result_source } = _umr

  const {
    _itemKey,
    _status,
    _results,
    isPlayoff,
    _results_matchDay,
    _results_realtime,
    startDate,
    away,
    home,
    pending
  } = match_true ?? {}

  let matchProps = {}

  // const _hasScore = !_.isEmpty(match_true?._results?.score);

  switch (matchDisplayType) {
    case _matchDisplayTypes.levelMatches:
    case _matchDisplayTypes.scoreboard:
      if (isPlayoff) {
        matchProps = {
          // startDate: match_true?.startDate ? matchPropTypes.startDate : null,
          startTime: hasScore ? null : matchPropTypes.startTime,
          matchNumber: match_true?.matchNumber ? matchPropTypes.matchNumber : null,
          awayName: match_true?.away?.name ? matchPropTypes.awayName : null,
          awaySeed: match_true?.seeds?.away ? matchPropTypes.awaySeed : null,
          homeName: match_true?.home?.name ? matchPropTypes.homeName : null,
          homeSeed: match_true?.seeds?.home ? matchPropTypes.homeSeed : null,
          locationName: match_true?.location?.name ? matchPropTypes.locationName : matchPropTypes.locationName,
          results: hasScore ? [matchPropTypes._resultsScoreAway, matchPropTypes._resultsScoreHome] : null,
          pendingAwayName: !away?.name && pending?.away?.name ? matchPropTypes.pendingAwayName : null,
          pendingHomeName: !home?.name && pending?.home?.name ? matchPropTypes.pendingHomeName : null,
          pendingAwaySeed: !away?.name && pending?.away?.seed ? matchPropTypes.pendingAwaySeed : null,
          pendingHomeSeed: !home?.name && pending?.home?.seed ? matchPropTypes.pendingHomeSeed : null,
          ls: match_true?.ls ? matchPropTypes.ls : null,
        }
      } else {
        matchProps = {
          // startDate: match_true?.startDate ? matchPropTypes.startDate : null,
          startTime: hasScore ? null : matchPropTypes.startTime,
          homeName: match_true?.home?.name ? matchPropTypes.homeName : null,
          awayName: match_true?.away?.name ? matchPropTypes.awayName : null,
          results: hasScore ? [matchPropTypes._resultsScoreAway, matchPropTypes._resultsScoreHome] : null,
          // ls: match_true?.ls ? matchPropTypes.ls : null,
        }
      }
      break;

    case _matchDisplayTypes.playoff_grid_dash:
      matchProps = {
        startDate: match_true?.startDate ? matchPropTypes.startDate : null,
        startTime: match_true?.startTime ? matchPropTypes.startTime : null,
        matchNumber: match_true?.matchNumber ? matchPropTypes.matchNumber : null,
        awayName: match_true?.away?.name ? matchPropTypes.awayName : null,
        awaySeed: match_true?.seeds?.away ? matchPropTypes.awaySeed : null,
        homeName: match_true?.home?.name ? matchPropTypes.homeName : null,
        homeSeed: match_true?.seeds?.home ? matchPropTypes.homeSeed : null,
        scoreAway: matchPropTypes._resultsScoreAway,
        scoreHome: matchPropTypes._resultsScoreHome,
        locationName: match_true?.location?.name ? matchPropTypes.locationName : matchPropTypes.locationName,
        // results: _hasScore ? [matchPropTypes._resultsScoreAway, matchPropTypes._resultsScoreHome] : null,
        pendingAwayName: !away?.name && pending?.away?.name ? matchPropTypes.pendingAwayName : null,
        pendingHomeName: !home?.name && pending?.home?.name ? matchPropTypes.pendingHomeName : null,
        pendingAwaySeed: !away?.name && pending?.away?.seed ? matchPropTypes.pendingAwaySeed : null,
        pendingHomeSeed: !home?.name && pending?.home?.seed ? matchPropTypes.pendingHomeSeed : null,
        // ls: match_true?.ls ? matchPropTypes.ls : null,
      }
      break;

    case _matchDisplayTypes.levelOverviewMatches:
      matchProps = {
        startDate: match_true?.startDate ? matchPropTypes.startDate : null,
        opponentName: match_true?.home?.name ? matchPropTypes.opponentName : null,
        results: hasScore ? [matchPropTypes._resultsScoreAway, matchPropTypes._resultsScoreHome] : null,
      }
      break;

    case _matchDisplayTypes.teamMatches:
      if (isPlayoff) {
        matchProps = {
          startDate: match_true?.startDate ? matchPropTypes.startDate : null,
          startTime: match_true?._results?.score ? null : matchPropTypes.startTime,
          opponentName: match_true?.home?.name ? matchPropTypes.opponentName : null,
          results: match_true?._results?.score ? [matchPropTypes._resultsScoreAway, matchPropTypes._resultsScoreHome] : null,
          ls: match_true?.ls ? matchPropTypes.ls : null,
        }
      } else {
        matchProps = {
          startDate: match_true?.startDate ? matchPropTypes.startDate : null,
          startTime: hasScore ? null : matchPropTypes.startTime,
          opponentName: match_true?.home?.name ? matchPropTypes.opponentName : null,
          results: hasScore ? [matchPropTypes._resultsScoreAway, matchPropTypes._resultsScoreHome] : null,
          ls: match_true?.ls ? matchPropTypes.ls : null,
        }
      }

      break;

    default:
      matchProps = {
        // startDate: match_true?.startDate ? matchPropTypes.startDate : null,
        startTime: match_true?._results?.score ? null : matchPropTypes.startTime,
        homeName: match_true?.home?.name ? matchPropTypes.homeName : null,
        awayName: match_true?.away?.name ? matchPropTypes.awayName : null,
        results: match_true?._results?.score ? [matchPropTypes._resultsScoreAway, matchPropTypes._resultsScoreHome] : null,
        // ls: match_true?.ls ? matchPropTypes.ls : null,
      }
  }


  let showScores;

  let _results_combined = _results ? _.cloneDeep(_results) : {}

  function combineResults(r, rmd, rrt) {

    // const hasScore = !_.isEmpty(r?.score);
    // const hasScores = !_.isEmpty(r?.scores);

    let result;

    if (!hasScore && !hasScores) {
      if (rrt) {
        result = _.merge({}, r, rrt);
        result._resultsFrom = "realtime";
      }
      if (rmd) {
        result = _.merge({}, r, rmd);
        result._resultsFrom = "matchDay";
      }
    } else {
      result = _.cloneDeep(r);
    }

    return result;
  }

  if (_results_matchDay || _results_realtime) {
    _results_combined = combineResults(_results, _results_matchDay, _results_realtime)
  }

  const { isMissing, isBye, isPending, isPendingish, isPendingAway } = _status ?? {}
  const { matchCn, complete, winner } = _results_combined ?? {}

  // const hasScore = !_.isEmpty(_results_combined?.score)
  // const hasScores = !_.isEmpty(_results_combined?.scores)
  const hasTrueScore = hasScores || hasScore

  const { _isPending, _isPendingA } = useMemo(() => {
    const _matchPlayoffPendings = matchFilterHelpers.matchesWithPendings(createPlayoff_state?.playoff_matchInfo?.matches)
    const pendingMatch = _matchPlayoffPendings?.[match_true?._itemKey]
    const _isPending = pendingMatch && !pendingMatch.home ? true : false
    const _isPendingA = pendingMatch && pendingMatch.home ? true : false
    return { _isPending, _isPendingA }
  }, [match_true])

  const mpt = useMemo(() => {
    let _matchPropType = matchDisplayType

    if (!complete && !_matchPropType?.includes('grid')) {
      switch (matchDisplayType) {
        case _matchDisplayTypes.teamMatches:
          _matchPropType = _matchDisplayTypes.teamMatchesNoScore
          break;
        default:
          if (isPending) {
            _matchPropType = _matchDisplayTypes.playoffMatchPending
          } else if (isPendingAway) {
            _matchPropType = _matchDisplayTypes.playoffMatchAwayPending
          } else {
            if (!results_match) {
              _matchPropType = _matchDisplayTypes.levelMatchNoScore
            }
          }
      }
    }

    if (isPlayoff) {
      switch (_matchPropType) {
        case _matchDisplayTypes.levelMatchNoScore:
        case _matchDisplayTypes.levelMatches:
        case _matchDisplayTypes.teamMatches:
        case _matchDisplayTypes.teamMatchesNoScore:
        case _matchDisplayTypes.scoreboard:
          _matchPropType = _matchPropType + '_playoffs';
          break;
      }
      if (_matchPropType === 'playoff_grid_dash') {
        if (isBye) {
          _matchPropType += '_noLoc'
        }
      }
    }

    if (_matchPropType === 'levelMatches' && matchUrl) {
      _matchPropType = _matchPropType + '_vid'
    }

    switch (matchDisplayType) {
      case _matchDisplayTypes.playoff_grid:
        // showScores = false
        if (!hasScores && !hasScore) {
          if (_isPending) {
            _matchPropType = _matchDisplayTypes.playoff_grid_pending
          } else if (_isPendingA) {
            _matchPropType = _matchDisplayTypes.playoff_grid_pendingA
          } else if (isPending) {
            _matchPropType = _matchDisplayTypes.playoff_grid_noScore_pending
          } else if (isPendingAway) {
            _matchPropType = _matchDisplayTypes.playoff_grid_noScore_pendingA
          } else {
            _matchPropType = _matchDisplayTypes.playoff_grid_noScore
          }
        }
        break;
      case _matchDisplayTypes.levelOverviewMatches:
        break;
      default:
    }
    return _matchPropType
  }, [JSON.stringify(match_true)])

  return (
    { mpt, matchProps }
  )
}
